import { Glyph, IconName } from '@uds/glyphs';
import { cssTheme } from '@uds/theme-utils';
import React, { ReactNode } from 'react';

import { getClassNames } from './ActionFeedback.stylesheet';
import { Kind } from './constants';

export const ActionFeedbackKind = Kind;

interface DefaultProps {
  kind?: Kind;
}

interface WithLabel extends DefaultProps {
  label: string | ReactNode;
  glyph?: IconName;
  glyphColor?: string;
}

interface OnlyGlyph extends DefaultProps {
  label?: string | ReactNode;
  glyph: IconName;
  glyphColor?: string;
}

export type Props = OnlyGlyph | WithLabel;

export const ActionFeedback = ({ label, glyph, glyphColor, kind = Kind.DEFAULT }: Props) => {
  const classNames = getClassNames({ kind });
  return (
    <div className={classNames.actionFeedback}>
      {label != null && <span className={classNames.actionFeedbackLabel}>{label}</span>}
      {glyph != null && (
        <span className={classNames.glyph}>
          <Glyph name={glyph} size={cssTheme.gu3} color={glyphColor ?? 'currentColor'} />
        </span>
      )}
    </div>
  );
};
